import './image-slider.scss';
